import { useQuery as rqUseQuery, } from 'react-query';
import { useTribeClient } from '../../useTribeClient';
export const useQuery = (key, fetchFn, options) => {
    const { ready } = useTribeClient();
    return rqUseQuery(key, fetchFn, {
        enabled: !ready ? false : options === null || options === void 0 ? void 0 : options.enabled,
        ...options,
    });
};
//# sourceMappingURL=useQuery.js.map